import styled from 'styled-components';

import {
  Tab as UnstyledTab,
  TabList as UnstyledTabList,
  Tabs as UnstyledTabs,
  TabPanel as UnstyledTabPanel,
} from 'react-tabs';

export const Container = styled.div`
  position: relative;
  -webkit-box-flex: 0;
  /* flex: 0 1 150px; */
  flex: 0 1 none;
  background: rgba(0, 0, 0, 0.2);
  width: 100%;
`;

export const Tabs = styled(UnstyledTabs)`
  /* border-bottom: 1px solid gray; */
  background: white;
  max-height: 175px;
  height: 175px;
`;

export const TabList = styled(UnstyledTabList)`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
`;

export const Tab = styled(UnstyledTab).attrs({
  selectedClassName: 'selected',
  disabledClassName: 'disabled',
})`
  flex-grow: 1;
  text-align: center;
  padding: 8px 0;
  list-style: none;
  cursor: pointer;
  color: #666;
  font-weight: bold;
  border-left: 1px solid gray;
  border-bottom: 1px solid gray;
  background-color: #eee;
  &:first-child {
    border-left: none;
  }

  &.selected {
    color: #000;
    background-color: white;
    border-bottom: none;
  }

  &.disabled {
    color: #ccc;
    cursor: not-allowed;
  }
`;

export const TabPanel = styled(UnstyledTabPanel).attrs({
  selectedClassName: 'selected',
})`
  display: none;
  padding: 0px 10px;
  &.selected {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
`;

Tab.tabsRole = 'Tab';
Tabs.tabsRole = 'Tabs';
TabPanel.tabsRole = 'TabPanel';
TabList.tabsRole = 'TabList';

export const TabPanelDescriptionContainer2 = styled.div`
  display: flex;
  justify-content: space-between;
  min-width: 100%;
  width: 100%;
  min-height: 1.2em;
  height: 20px;
  margin-top: 5px;
`;

export const TabPanelDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: 10px;
  & label {
    margin: 0px;
    font-size: 0.8em;
    /* font-weight: bold; */
    text-transform: uppercase;
  }
  & span {
    width: 100%;
    padding: 0px;
    & input {
      width: 100%;
      height: 25px;
      font-size: 0.8em;
      /* font-weight: bold; */
      border: 1px solid gray;
      border-radius: 3px;
      &:focus:-webkit-placeholder {
        color: transparent;
      }
      &:focus {
        outline: none;
        background-color: rgba(0, 128, 0, 0.115);
      }
    }
    & ul {
      width: 325px;
      resize: horizontal;
    }
    & ul,
    li {
      font-size: 1em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      &.active {
      }
    }
  }
  /* & button {
    color: #fff;
    width: 50px;
    z-index: 2;
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
    border-left: none;
    border-top: 1px solid gray;
    border-right: 1px solid gray;
    border-bottom: 1px solid gray;
    background-color: #008000;
    padding: 0px;
    :disabled,
    :disabled i {
      cursor: not-allowed;
      background-color: #e7e7e7;
      color: #666;
    }
    &:focus {
      outline: none;
    }
    & i {
      color: #fff;
      font-size: 1.5em;
      padding: 0px;
    }
  } */
`;

export const ChooseTemplateLink = styled.a`
  font-size: 0.8em;
  text-decoration: underline;
  color: blue;
`;
export const TabPanelLabel = styled.label`
  font-size: 0.8em;
  margin-bottom: 3px;
`;

export const ReplyToLabel = styled(TabPanelLabel)`
  color: #DB2828;
`;

export const TabPanelEmphasisLabel = styled(TabPanelLabel)`
  font-style: italic;
`;

export const TabPanelInput = styled.textarea`
  background-color: white;
  outline: none !important;
  resize: none;
  border: 1px solid gray;
  border-radius: 3px;
  font-family: 'Roboto', sans-serif;
  font-size: 0.9em;
  min-height: 50px;
  margin: 0;
  padding: 0px;
  width: 100%;
  padding: 3px;
  &:focus:-webkit-placeholder {
    color: transparent;
  }
`;

export const TabPanelButton = styled.button`
  color: #fff;
  border: none;
  align-self: flex-end;
  margin-top: 5px;
  border-radius: 3px;
  font-size: 0.8em;
  text-transform: uppercase;
  padding: 6px 10px;
  outline: none !important;
  height: 25px;
  & i {
    padding-right: 5px;
  }
`;

export const SubmitButton = styled(TabPanelButton)`
  background: ${(props) => props.bgColor};
  &:disabled {
    cursor: not-allowed;
    opacity: 0.3;
  }
`;

export const ItemInputContainer = styled.span`
  float: left;
  & input {
    width: 100px;
    height: 25px;
    font-size: 0.8em;
    padding-left: 5px;
    border: 1px solid gray;
    border-radius: 3px;
    &:focus:-webkit-placeholder {
      color: transparent;
    }
    &:focus {
      outline: none;
    }
  }
`;

export const InputButtonGroup = styled.div`
  display: flex;
  width: 100%;
  height: 30px;
`;
